export const getUserMessageWithContext = ({ userMessage, messageContext }) =>
  messageContext !== null
    ? messageContext.reduce(
        (output, replacement, index) =>
          output.replace(`{${index}}`, replacement),
        userMessage
      )
    : userMessage;
